<template>
  <div>
    <label class="pre-inline">{{pre_item.name}}:</label>

    <el-date-picker v-model="pre_item.val" type="week" :class="[pre_item.class==''?'short0':pre_item.class]"
      placeholder="选择星期">
    </el-date-picker>

    <em v-show="pre_item.w=='1'">*</em><em v-show="pre_item.w=='0'"></em>
  </div>
</template>

<script>
  //
  export default {
    name: "hj-dateweek",
    data() {
      return {
        pre_item: {},
      }
    },
    props: {
      inData: {
        type: String,
        default: ''
      }
    },
    watch: {
      inData(val) {
        this.pre_item = {};
        this.pre_item = JSON.parse(this.inData);
      }
    },
    created() {
      this.pre_item = {};
      this.pre_item = JSON.parse(this.inData);
      // console.log(this.pre_item);
    },
    activated: function() {
      // console.log('hj-input 组件激活时调用 激活');
      this.pre_item = {};
      this.pre_item = JSON.parse(this.inData);
    },
    deactivated: function() {
      // console.log('hj-input 组件激活时调用 停用');
      this.pre_item = {};
    },
    methods: {
      val_back: function() {
        this.$emit('com-event', this.pre_item);
      }
    }
  }
</script>

<style scoped="scoped">
  .pre-inline {
    display: inline-block;
    vertical-align: bottom;
  }
</style>
